import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

import useRedirect from "data/hub/hooks";

import { useBooleanState } from "hooks";

export function NameLinker({ children, url, icon, openInNewTab }) {
  const [isHovered, setHovered, setNotHovered] = useBooleanState();
  const redirect = useRedirect();

  return (
    <React.Fragment>
      <div
        onClick={(e) => {
          e.stopPropagation();

          const open = openInNewTab ? window.open : redirect;
          open(url);
        }}
        onMouseEnter={setHovered}
        onMouseLeave={setNotHovered}
        style={{
          display: "inline",
          textDecoration: isHovered ? "underline" : "",
          marginRight: "0.5em",
          cursor: "pointer",
        }}
      >
        {children}
      </div>
      {icon && (
        <Icon
          name={icon}
          data-test="name-linker-icon"
          color="grey"
          style={{ visibility: isHovered ? "visible" : "hidden" }}
        />
      )}
    </React.Fragment>
  );
}

NameLinker.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
  icon: PropTypes.string,
  openInNewTab: PropTypes.bool,
};

NameLinker.defaultProps = {
  icon: "external alternate",
  openInNewTab: true,
};

export default NameLinker;
